/* eslint-disable max-lines-per-function */
import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { Formik } from 'formik';
import { validacaoFormImagens } from '../helpers/validacao';
import TvService from '../../../../services/tvs/TvService.js';

//import { Selection } from 'primereact/sele';
import { FormCadastrarTv } from '../components/formCadastroTV';
import { excludeNull } from '../function/excludeNull';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function EditarTvs({
    rowSelecionada,
    modalEdicaoAberto,
    setModalEdicaoAberto,
    setRecarregarDataTable
}) {
    const mensagemToast = useRef(null);

    const fecharModal = () => setModalEdicaoAberto(false);
    const valoresIniciaisTVs = {
        nome: rowSelecionada.nome,
        logradouro:rowSelecionada.logradouro,
        numero:rowSelecionada.numero,
        bairro:rowSelecionada.bairro,
        cidade:rowSelecionada.cidade,
        estado:rowSelecionada.estado,
        cep:rowSelecionada.cep       
       
    };

    const editarTV = async values => {
        try {
            const dados = excludeNull(values);
        
            await TvService.atualizaTV(dados, rowSelecionada.id);
            fecharModal();
            setRecarregarDataTable(true);             
            mostrarMensagemSucesso(mensagemToast,'Alterado com sucesso!');
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Não foi possível alterar os dados! Tente novamente mais tarde.');
            throw new Error(error);
        }
    };

    return (
        <div>
            <Growl ref={mensagemToast} />
            <Dialog
                header={'Editar Aparelho televisor'}
                visible={modalEdicaoAberto}
                dismissableMask
                onHide={fecharModal}                
            >
                <div style={{ width: '60vw' }}>                     
                    <Formik
                        onSubmit={editarTV}
                        initialValues={valoresIniciaisTVs}
                        validationSchema={validacaoFormImagens}
                    >
                        <FormCadastrarTv nomebotao={'Atualizar'}></FormCadastrarTv>
                    </Formik>
                </div>
            </Dialog>
        </div>
    );
}
